import { render } from "./LoanCard.vue?vue&type=template&id=1c0ca74e&scoped=true"
import script from "./LoanCard.vue?vue&type=script&lang=js"
export * from "./LoanCard.vue?vue&type=script&lang=js"

import "./LoanCard.vue?vue&type=style&index=0&id=1c0ca74e&scoped=true&lang=css"

import exportComponent from "/var/www/html/loans-pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0ca74e"]])

export default __exports__